module.exports = __webpack_public_path__ + "fonts/800-normal-cyrillic-ext.754858d.woff2";